import { useCopyToClipboard } from 'usehooks-ts'
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CheckIcon from '@mui/icons-material/Check';

import '../App.css';

function Error() {
  const [value, copy] = useCopyToClipboard()
  const exampleText = `https://zengarden.descope.io/?theme=default`

  return (
    <div className='page error fullscreen' data-cy="error-page">
      <h1 className='title error-title'>Hmmmmm</h1>
      <p>Are you lost?</p>
      <p className='error-txt'>Please make sure the URL is correctly formatted with a valid theme id.</p>
      <p className='error-blue'>Here's an example: </p>
      <p className='example' onClick={() => copy(exampleText)}>{exampleText}
        {value ?
          <CheckIcon className='copy-icon' />
          :
          <ContentCopyIcon className='copy-icon' />
        }
      </p>
    </div>
  )
}


export default Error
